(function () {
    'use strict';

    angular
    .module('app')
    .directive('fileUpload', fileUploadDirective);

    function fileUploadDirective() {
        var directive = {
            restrict: 'E',
            scope: {
                ngModel: '=',
            },
            templateUrl: '/templates/directives/file-upload.directive.html',
            link: link,
        };

        function link (scope, elem, attrs) {
            scope.previewSrc = '';
            scope.fileModel = '';
            scope.fileString = '';
            scope.isDragging = false;
            scope.file = {};
            scope.removeFile = removeFile;

            scope.$watch('fileString', function(newValue) {
                if (newValue) {
                    scope.showFile(newValue);
                }
            });

            scope.$watch('ngModel', function(newValue) {
                if (newValue) {
                    scope.showFile(newValue);
                }
            });

            elem.on('drop', function(ev) {
                ev.stopPropagation();
                ev.preventDefault();
                scope.isDragging = false;

                var files = ev.dataTransfer.files;
                scope.showFile(files[0]);
            });

            elem.on('dragenter', function(ev) {
                ev.stopPropagation();
                ev.preventDefault();
                scope.isDragging = true;
            });

            elem.on('dragleave', function(ev) {
                ev.stopPropagation();
                ev.preventDefault();
                scope.isDragging = false;
            });

            scope.showFile = function(file) {
                // If file is url to file
                if (angular.isString(file) && file.indexOf('://')) {
                    scope.file = {};
                    scope.previewSrc = file;
                    scope.ngModel = file;
                    return;
                }

                var reader = new FileReader();
                reader.readAsDataURL(file);

                reader.addEventListener('load', function () {
                    // convert image file to base64 string
                    scope.$apply(function() {
                        scope.file = file;
                        scope.previewSrc = reader.result;
                        scope.ngModel = reader.result;
                    });
                }, false);
            };

            activate();

            function activate() {
                if (attrs['ng-model']) {
                    scope.$apply(function() {
                        scope.previewSrc = attrs['ng-model'];
                    });
                }
            }

            function removeFile() {
                scope.file = {};
                scope.previewSrc = '';
                scope.ngModel = '';
            }
    }


    return directive;
}

})();